let documentListenersAttached = false

const closeAllDropdowns = () => {
	document.querySelectorAll('[data-el="quickbar-dropdown"]').forEach((dropdown) => {
		const toggle = dropdown.querySelector('.toggle')
		const menu = dropdown.querySelector('.menu')
		if (toggle) toggle.setAttribute('aria-expanded', 'false')
		if (menu) menu.setAttribute('hidden', '')
	})
}

export const quickbar = () => {
	const bar = document.querySelector('[data-el="quickbar"]')
	if (!bar) return

	const dropdowns = bar.querySelectorAll('[data-el="quickbar-dropdown"]')

	dropdowns.forEach((dropdown) => {
		const toggle = dropdown.querySelector('.toggle')
		const menu = dropdown.querySelector('.menu')
		if (!toggle || !menu) return

		toggle.addEventListener('click', (event) => {
			event.stopPropagation()
			const isOpen = toggle.getAttribute('aria-expanded') === 'true'
			closeAllDropdowns()
			if (!isOpen) {
				toggle.setAttribute('aria-expanded', 'true')
				menu.removeAttribute('hidden')
			}
		})

		menu.addEventListener('click', (event) => {
			event.stopPropagation()
		})
	})

	if (!documentListenersAttached) {
		document.addEventListener('click', (event) => {
			if (!event.target.closest('[data-el="quickbar-dropdown"]')) {
				closeAllDropdowns()
			}
		})

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') closeAllDropdowns()
		})

		documentListenersAttached = true
	}
}

export default () => { }
